import { CreateJobsStep } from './steps/CreateJobs';
import { ErrorStep } from './steps/Error';
import { SelectFilesStep } from './steps/SelectFiles';
import { SubmitPriceStep } from './steps/SubmitPrice';
import { SuccessStep } from './steps/Success';
import { UploadFilesStep } from './steps/UploadFiles';

export const BulkCreateJobsModalContent = () => {
  return (
    <>
      <SelectFilesStep />
      <UploadFilesStep />
      <CreateJobsStep />
      <SubmitPriceStep />
      <SuccessStep />
      <ErrorStep />
    </>
  );
};
